import api from './api';

export const authService = {
  getLoginUrl: async () => {
    const response = await api.get('/auth/login');
    return response.data.login_url;
  },

  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },
};
